import { Badge, Box, Button, Stack, Text, Tooltip } from '@mantine/core';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import { faList } from '@fortawesome/pro-solid-svg-icons';

const SegmentsCell = ({ cell, openModal }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
                gap: '16px',
            }}>
            <Badge>{rowData.transcript.segments.length}</Badge>
            <Tooltip label={'Show call transcript'}>
                <Button
                    size={'compact-xs'}
                    onClick={() => openModal(rowData)}>
                    <FontAwesomeIcon icon={faList} />
                </Button>
            </Tooltip>
        </Box>
    );
};

const SegmentsColumn = ({ openModal }) => ({
    accessorKey: 'transcript.segments',
    header: 'Segments',
    size: 1,
    Cell: ({ cell }) => (
        <SegmentsCell
            cell={cell}
            openModal={openModal}
        />
    ),
});
export default SegmentsColumn;
